import { InjectionToken } from "@angular/core";
import { BaseViewerService } from "./base-viewer.service";

export const VIEWER_SERVICE = new InjectionToken<BaseViewerService>("ViewerService");
